import React, { useState } from "react";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import FunctionButton from "../../components/common/FunctionButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import InputWrapDiv from "../../components/common/InputWrapDiv";
import TopBoxDiv from "../../components/common/TopBoxDiv";
import ContentInput from "../../components/common/ContentInput";
import ValidMsgSpan from "../../components/common/ValidMsgSpan";
import { useTranslation } from "react-i18next";

const ApproveIdPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [userId, setUserId] = useState("");
  const [email, setEmail] = useState("");

  const handleUserIdChange = (e) => {
    setUserId(e.target.value.trim());
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value.trim());
  };

  const handleSubmitClick = () => {
    if (!validate()) {
      return;
    }

    api
      .post("/user/approval", {
        userId: userId,
        email: email,
      })
      .then(() => {
        let tempErrors = {};
        tempErrors.validSubmit = t("L0103");
        setErrors(tempErrors);
      })
      .catch((error) => {
        let tempErrors = {};
        if (error.response.data.result == "1039") {
          tempErrors.validSubmit = t("L0093");
          setErrors(tempErrors);
        } else if (error.response.data.result == "1040") {
          tempErrors.validSubmit = t("L1089");
          setErrors(tempErrors);
        } else {
        }
      });
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  const [errors, setErrors] = useState({
    validUserId: "",
    validEmail: "",
    validSubmit: "",
  });

  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (!userId) {
      tempErrors.validUserId = "User ID is required.";
      isValid = false;
    }

    if (!email) {
      tempErrors.validEmail = "Email is required.";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("L0341"), t("L0382")]}></BreadCrumbDiv>

      <InputWrapDiv>
        <TopBoxDiv value={t("L0381")}></TopBoxDiv>
        <table>
          <tbody>
            <tr>
              <th>
                {t("L0185")}
                {errors.validUserId && (
                  <>
                    <br />
                    <ValidMsgSpan value={errors.validUserId}></ValidMsgSpan>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  value={userId}
                  width="100%"
                  maxLength={250}
                  onChange={handleUserIdChange}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>
                {t("L0369")}
                {errors.validEmail && (
                  <>
                    <br />
                    <ValidMsgSpan value={errors.validEmail}></ValidMsgSpan>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  value={email}
                  width="100%"
                  maxLength={250}
                  onChange={handleEmailChange}
                ></ContentInput>
              </td>
              <td style={{ width: "80px" }}>
                <FunctionButton
                  value={t("L0659")}
                  className="small"
                  onClick={handleSubmitClick}
                ></FunctionButton>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="tc">
          {errors.validSubmit && (
            <>
              <br />
              <ValidMsgSpan
                value={errors.validSubmit}
                className={"f14"}
              ></ValidMsgSpan>
            </>
          )}
        </div>
        <ButtonWrapDiv className="btn_bottom">
          <FunctionButton
            value={t("L0188")}
            className="big"
            onClick={handleLoginClick}
          ></FunctionButton>
        </ButtonWrapDiv>
      </InputWrapDiv>
    </div>
  );
};

export default ApproveIdPage;
